export default function extractCollection(response: any): Collection<any> {
  return (
    response?.data?.collection ?? { items: [], skip: 0, limit: 0, total: 0 }
  );
}
